// Source/Steps-Block/Component.ts
import { Swiper } from "Swiper";
class Steps_Block extends HTMLElement {
  controller;
  swiper;
  connectedCallback() {
    this.controller = new AbortController;
    this.swiper = new Swiper(this.$swiper, {
      updateOnWindowResize: true,
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 27,
      direction: "horizontal",
      breakpoints: {
        800: {
          centeredSlides: true,
          autoHeight: true,
          slidesPerView: "auto",
          spaceBetween: 27,
          direction: "vertical"
        }
      }
    });
    const { $backward, $forward, $previews, $tabs } = this;
    const { signal } = this.controller;
    $backward.forEach((button) => {
      button.addEventListener("click", () => {
        this.swiper.slidePrev();
        this.updateInputs(this.swiper.activeIndex + 1);
      }, { signal });
    });
    $forward.forEach((button) => {
      button.addEventListener("click", () => {
        this.swiper.slideNext();
        this.updateInputs(this.swiper.activeIndex + 1);
      }, { signal });
    });
    $previews.forEach((input) => {
      input.addEventListener("change", () => {
        const position = Number(input.value);
        const index = position - 1;
        console.debug("Preview Change", { index });
        this.swiper.slideTo(index);
        this.updateInputs(position);
      }, { signal });
    });
    $tabs.forEach((input) => {
      input.addEventListener("change", () => {
        const position = Number(input.value);
        const index = position - 1;
        console.debug("Tab Change", { index });
        this.swiper.slideTo(index);
        this.updateInputs(position);
      }, { signal });
    });
    this.swiper.on("slideChange", () => {
      this.updateActive();
    });
    this.updateInputs(1);
    this.updateActive();
  }
  disconnectedCallback() {
    this.controller.abort();
    this.swiper.destroy();
  }
  updateInputs(position) {
    console.debug("updateInputs", { position });
    const preview = this.querySelector(`.Step-Preview input[ value = '${position}' ]`);
    preview.checked = true;
    const tab = this.querySelector(`.Steps-Tabs input[ value = '${position}' ]`);
    tab.checked = true;
  }
  updateActive() {
    const at_begin = this.swiper.isBeginning;
    const at_end = this.swiper.isEnd;
    console.debug("updateActive", { at_begin, at_end });
    this.dataset.atBegin = String(at_begin);
    this.dataset.atEnd = String(at_end);
  }
  get $swiper() {
    return this.querySelector(`.swiper`);
  }
  get $backward() {
    return this.querySelectorAll(`[ part = 'Backward' ]`);
  }
  get $forward() {
    return this.querySelectorAll(`[ part = 'Forward' ]`);
  }
  get $previews() {
    return this.querySelectorAll(`.Step-Preview input`);
  }
  get $tabs() {
    return this.querySelectorAll(`.Steps-Tabs input`);
  }
}

// Source/Steps-Block/mod.ts
customElements.define("steps-block", Steps_Block);
